import React, { Component } from 'react';
import { FormGroup, DropdownButton, MenuItem, ControlLabel, FormControl } from 'react-bootstrap';
import { keyBy, map, each, filter, cloneDeep } from 'lodash';
import {jobServiceStatuses} from '../../constants/staticData';
import Select from '../Results/Select';
// import InspectionRequired from "./inspectionRequired";

class Quotes extends Component {
  constructor(props) {
    super(props);
    let userbookingRequestServices = cloneDeep(keyBy(props.requestDetails.userbookingrequest_services, 'serviceId'));
    let quotesListByServiceId = cloneDeep(keyBy(props.requestDetails.quotesList, 'serviceId'));
    each(userbookingRequestServices, (service) => {
      if (quotesListByServiceId && quotesListByServiceId[service.serviceId]) {
        service.amount = quotesListByServiceId[service.serviceId].amount || '--'
        service.jobdetailstatusId = quotesListByServiceId[service.serviceId].jobdetailstatusId || 0
      }
    });
    this.state = {
      quotesGrouped: props.requestDetails.quotesGrouped,
      userbookingRequestServices: userbookingRequestServices,
      garageJobQuoteArr: (this.props.requestDetails.garagejobquote && this.props.requestDetails.garagejobquote.garagejobquotesdetail),
    };
  }

  componentWillMount() {

  }
  componentWillReceiveProps(nextProps) {
    console.log("present in will props");
    if (this.props.requestDetails.userbookingrequestId != nextProps.requestDetails.userbookingrequestId) {
      let userbookingRequestServices = cloneDeep(keyBy(nextProps.requestDetails.userbookingrequest_services, 'serviceId'));
      let quotesListByServiceId = cloneDeep(keyBy(nextProps.requestDetails.quotesList, 'serviceId'));
      each(userbookingRequestServices, (service) => {
        if (quotesListByServiceId && quotesListByServiceId[service.serviceId]) {
          service.amount = quotesListByServiceId[service.serviceId].amount || '--'
          service.jobdetailstatusId = quotesListByServiceId[service.serviceId].jobdetailstatusId || 0
        }
      });
      this.setState({
        quotesGrouped: nextProps.requestDetails.quotesGrouped,
        userbookingRequestServices: userbookingRequestServices
      });
    }

  }
  // onStatusChange(serviceId, jobdetailstatusId) {
  //   const jobStatus = this.props.requestDetails.jobStatus.replace(/\s+/, "").toLowerCase();
  //   if (this.state.garageJobQuoteArr && this.state.garageJobQuoteArr.length) {
  //     let garageJobQuoteArr = cloneDeep(this.state.garageJobQuoteArr);
  //     garageJobQuoteArr.forEach((item) => {
  //       if(item.serviceId == serviceId) {
  //         item.jobdetailstatusId = jobdetailstatusId;
  //       }
  //     });
  //     this.setState({
  //       'garageJobQuoteArr': garageJobQuoteArr
  //     });
  //     let nextJobStatus = '';
  //     each(garageJobQuoteArr, (service) => {
  //       if (service.jobdetailstatusId != 7) {
  //         nextJobStatus = 'In Progress';
  //       }
  //     });
  //     if (!nextJobStatus) {
  //       nextJobStatus = 'Completed';
  //     }
  //     let updatedQuotesList = cloneDeep(this.props.requestDetails.garagejobquote.garagejobquotesdetail);
  //     each(updatedQuotesList, (quote) => {
  //       if (quote.serviceId == serviceId) {
  //         quote.jobdetailstatusId = jobdetailstatusId;
  //       }
  //     });
  //     this.props.actions.updateJobStatus(this.props.requestDetails.userbookingrequestId, {
  //       "serviceid": serviceId,
  //       "statusid": jobdetailstatusId,
  //       "nextJobStatus": nextJobStatus,
  //       "currentJobStatus": jobStatus,
  //       "updatedQuotesList": updatedQuotesList
  //     });
  //   }
  //   else {
  //     let userbookingRequestServices = cloneDeep(this.state.userbookingRequestServices);
  //     userbookingRequestServices[serviceId].jobdetailstatusId = jobdetailstatusId;
  //     this.setState({
  //       'userbookingRequestServices': userbookingRequestServices
  //     });
  //     let nextJobStatus = '';
  //     each(userbookingRequestServices, (service) => {
  //       if (service.jobdetailstatusId != 7) {
  //         nextJobStatus = 'In Progress';
  //       }
  //     });
  //     if (!nextJobStatus) {
  //       nextJobStatus = 'Completed';
  //     }
  //     let updatedQuotesList = cloneDeep(this.props.requestDetails.quotesList);
  //     each(updatedQuotesList, (quote) => {
  //       if (quote.serviceId == serviceId) {
  //         quote.jobdetailstatusId = jobdetailstatusId;
  //       }
  //     });
  //     this.props.actions.updateJobStatus(this.props.requestDetails.userbookingrequestId, {
  //       "serviceid": serviceId,
  //       "statusid": jobdetailstatusId,
  //       "nextJobStatus": nextJobStatus,
  //       "currentJobStatus": jobStatus,
  //       "updatedQuotesList": updatedQuotesList
  //     });
  //   }
  // }

  onStatusChange(serviceId, jobdetailstatusId) {
    const jobStatus = this.props.requestDetails.jobStatus.replace(/\s+/, "").toLowerCase();
    if (this.state.garageJobQuoteArr && this.state.garageJobQuoteArr.length) {
      let garageJobQuoteArr = cloneDeep(this.state.garageJobQuoteArr);
      garageJobQuoteArr.forEach((item) => {
        if(item.serviceId == serviceId) {
          item.jobdetailstatusId = jobdetailstatusId;
        }
      });
      this.setState({
        'garageJobQuoteArr': garageJobQuoteArr
      });
      console.log("id: = ", jobdetailstatusId, garageJobQuoteArr);
      let nextJobStatus = '';
      each(garageJobQuoteArr, (service) => {
        if (service.jobdetailstatusId != 7) {
          nextJobStatus = 'In Progress';
        }
      });
      if (!nextJobStatus) {
        nextJobStatus = 'Completed';
      }
      let updatedQuotesList = cloneDeep(this.props.requestDetails.garagejobquote.garagejobquotesdetail);
      each(updatedQuotesList, (quote) => {
        if (quote.serviceId == serviceId) {
          quote.jobdetailstatusId = jobdetailstatusId;
        }
      });
      console.log("updatedQuotesList = ", updatedQuotesList, this.props.requestDetails.garagejobquote.garagejobquotesdetail);
      this.props.actions.updateJobStatus(this.props.requestDetails.userbookingrequestId, {
        "serviceids": [serviceId],
        "statusid": jobdetailstatusId,
        "nextJobStatus": nextJobStatus,
        "currentJobStatus": jobStatus,
        "updatedQuotesList": updatedQuotesList
      });
    }
    else {
      let userbookingRequestServices = cloneDeep(this.state.userbookingRequestServices);
      userbookingRequestServices[serviceId].jobdetailstatusId = jobdetailstatusId;
      this.setState({
        'userbookingRequestServices': userbookingRequestServices
      });
      let nextJobStatus = '';
      each(userbookingRequestServices, (service) => {
        if (service.jobdetailstatusId != 7) {
          nextJobStatus = 'In Progress';
        }
      });
      if (!nextJobStatus) {
        nextJobStatus = 'Completed';
      }
      let updatedQuotesList = cloneDeep(this.props.requestDetails.quotesList);
      each(updatedQuotesList, (quote) => {
        if (quote.serviceId == serviceId) {
          quote.jobdetailstatusId = jobdetailstatusId;
        }
      });
      this.props.actions.updateJobStatus(this.props.requestDetails.userbookingrequestId, {
        "serviceids": [serviceId],
        "statusid": jobdetailstatusId,
        "nextJobStatus": nextJobStatus,
        "currentJobStatus": jobStatus,
        "updatedQuotesList": updatedQuotesList
      });
    }
  }


  render() {


    const {
      requestDetails,
      jobRequestReducer,
      vat
    } = this.props;
    const jobStatus = requestDetails.jobStatus ? requestDetails.jobStatus.toLowerCase() : this.props.jobStatus;
    let quotesViewArr = [];
    console.log('🍻 🍻 🍻 ', this.props.requestDetails);
    if (this.state.garageJobQuoteArr && this.state.garageJobQuoteArr.length) {
      let qArr = this.props.requestDetails.garagejobquote.garagejobquotesdetail;
      console.log('🍻 🍻 🍻 QARRR .. ', qArr);
      let result = qArr.reduce((h, a) => Object.assign(h, { [a.parent.name]:( h[a.parent.name] || [] ).concat(a) }), {});
      console.log("qArr result = ", result);
      let gropuQArr = [];
      Object.keys(result).map((key)=>{
        let obj = {};
        console.log("key name & value = ", key, result[key]);
        obj = {
          groupName: key,
          value: result[key]
        };
        gropuQArr.push(obj);
      });
      quotesViewArr = map(gropuQArr, (categories, key) => {
        return (
          <div className="quotesSection-categories" key={categories.groupName}>
            {(categories.groupName.toLowerCase() != 'wash' && categories.groupName.toLowerCase() != 'repair' && categories.groupName.toLowerCase() != 'service') && <h5>
              {/* <i className="mdi mdi-delete" /> */}
              <span>{categories.groupName}</span>
            </h5>}
            {map(categories.value, (category, categoryKey) => {
              return (jobStatus != 'waiting' && jobStatus != 'applied')
                ?
                (<div>
                  <div className="quotesSection-subcategories row quotes-section-text" key={categoryKey}>
                  <div className="col-md-6 pad0">
                    <label>
                      {/* <i className="mdi mdi-delete" /> */}
                      <span>{category.name}</span>
                    </label>
                  </div>
                  <div className="col-md-3 pad0">
                    {(jobStatus == 'confirmed' || jobStatus == 'inprogress' || jobStatus == 'in progress') && <Select data={jobServiceStatuses} title="Status" isJobService={true} disabled={category.jobdetailstatusId == 7} selectedId={category.jobdetailstatusId} onChange={(id) => { this.onStatusChange(category.serviceId, id) }} />}
                  </div>
                  <div className="col-md-3 pad0">
                    <div className="quotes-amount-card qoutes-amount-card-slide">
                      <span className="accessories-cost"> <span className="accessories-amt">{category.amount > 0 ? Number(category.amount).toFixed(2) : 0}</span> AED</span>
                    </div>
                  </div>
                </div>
                </div>)
                :
                (<div>
                  <div className="quotesSection-subcategories row quotes-section-text" key={categoryKey}>
                  <div className="col-md-9 pad0">
                    <label>
                      {/* <i className="mdi mdi-delete" /> */}
                      <span>{category.name}</span>
                    </label>
                  </div>
                  {/*<div className="col-md-4 pad0">
                    {<Select data={statusType} title="Status" />}
                  </div>*/}
                  <div className="col-md-3 pad0">
                    <div className="quotes-amount-card">
                      <span className="accessories-cost pull-right" style={{color: '#717982'}}> {Number(category.amount).toFixed(2)  || 0} AED</span>
                    </div>
                  </div>
                </div>

                </div>);
            })}
            {/* <a className="add-category">Add Sub Category</a> */}
          </div>
        )
      });
    }
    else {
      quotesViewArr = map(this.state.quotesGrouped, (categories, key) => {
        return (
          <div className="quotesSection-categories" key={key}>
            {(key.toLowerCase() != 'wash' && key.toLowerCase() != 'repair' && key.toLowerCase() != 'service') && <h5>
              {/* <i className="mdi mdi-delete" /> */}
              <span>{key}</span>
            </h5>}
            {map(categories, (category, categoryKey) => {
              return (jobStatus != 'waiting' && jobStatus != 'applied')
                ?
                (<div className="quotesSection-subcategories row quotes-section-text" key={categoryKey}>
                  <div className="col-md-6 pad0">
                    <label>
                      {/* <i className="mdi mdi-delete" /> */}
                      <span>{this.state.userbookingRequestServices[category.serviceId].name}</span>
                    </label>
                  </div>
                  <div className="col-md-3 pad0">
                    {(jobStatus == 'confirmed' || jobStatus == 'inprogress' || jobStatus == 'in progress') && <Select data={jobServiceStatuses} title="Status" isJobService={true} disabled={this.state.userbookingRequestServices[category.serviceId].jobdetailstatusId == 7} selectedId={this.state.userbookingRequestServices[category.serviceId].jobdetailstatusId} onChange={(id) => { this.onStatusChange(category.serviceId, id) }} />}
                  </div>
                  <div className="col-md-3 pad0">
                    <div className="quotes-amount-card qoutes-amount-card-slide">
                      <span className="accessories-cost"> <span className="accessories-amt">{Number(this.state.userbookingRequestServices[category.serviceId].amount).toFixed(2) }</span> AED</span>
                    </div>
                  </div>
                </div>)
                :
                (<div className="quotesSection-subcategories row quotes-section-text" key={categoryKey}>
                  <div className="col-md-9 pad0">
                    <label>
                      {/* <i className="mdi mdi-delete" /> */}
                      <span>{this.state.userbookingRequestServices[category.serviceId].name}</span>
                    </label>
                  </div>
                  {/*<div className="col-md-4 pad0">
                    {<Select data={statusType} title="Status" />}
                  </div>*/}
                  <div className="col-md-3 pad0">
                    <div className="quotes-amount-card">
                      <span className="accessories-cost pull-right" style={{color: '#717982'}}> {this.state.userbookingRequestServices[category.serviceId].amount || 0} AED</span>
                    </div>
                  </div>

                </div>)
            })}

            {/* <a className="add-category">Add Sub Category</a> */}
          </div>
        )
      });
    }
    const quotesView = quotesViewArr;

    var subTotalAmount = requestDetails.garagejobquote.discountAmount?requestDetails.garagejobquote.totalamount-requestDetails.garagejobquote.discountAmount:requestDetails.garagejobquote.totalamount;


    var vatAmount = vat? subTotalAmount ? Number(subTotalAmount) *( Number(requestDetails.garagejobquote.garage.garage_taxes[0].value)/100): 0: 0;
    //
    var totalAmount = subTotalAmount? Number(subTotalAmount)+Number(vatAmount) : 0;


    return (
      <div>
          <div className="jobSlider-quotes">
            {(requestDetails.jobStatus == 'waiting')
              ? (<div className="jobSlider-quotes-header">
                  <div className="desc-block width-50">
                    <h5>Job Preffered Date :</h5>
                    <span>{requestDetails.jobPrefferedDate}</span>
                  </div>
                  <div className="desc-block inlineBlock">
                    <h5>Job Preffered Time :</h5>
                    <span>{requestDetails.jobPrefferedTime}</span>
                  </div>
                </div>)
              : (
                (<div>
                  <div className="desc-block width-50">
                    <h5>Job Start Date :</h5>
                    <span>{requestDetails.jobStartDate}</span>
                  </div>
                  <div className="desc-block inlineBlock pull-right">
                    <h5>Job Start Time :</h5>
                    <span>{requestDetails.jobStartTime}</span>
                  </div>
                  <div className="desc-block width-50">
                    <h5>Job End Date :</h5>
                    <span>{requestDetails.jobEndDate || '-'}</span>
                  </div>
                  <div className="desc-block inlineBlock pull-right">
                    <h5>Job End Time :</h5>
                    <span>{requestDetails.jobEndTime || '-'}</span>
                  </div>
                </div>)
              )
            }
            <div>
              <div className="jobSlider-quotes-content">
                <div className="desc-block jobSlider-quotes-content-head">
                  <div>
                      <h5 className="quotes-content-title"> {requestDetails.serviceType} Type:</h5>
                      <span className="quotes-amount-title pull-right">Amount:</span>
                  </div>
                </div>
                {quotesView}
                {requestDetails && requestDetails.offer && requestDetails.offer.promoCode && <div>
                  <div className="promo-offer-block">
                    <div>
                      Promo Code <span className="promo-offer-code">'{requestDetails.offer.promoCode}'</span>
                      {/*<label> {offerDiscount? "-" : "" } {offerDiscount}  {garageQuotesPricingDetails && garageQuotesPricingDetails.currency}</label>*/}
                    </div>
                  </div>

                  {requestDetails.offer && requestDetails.offer.discountPercentage?
                    <div className="promo-offer-block-percent">
                      <div>
                        <span className="promo-offer-code"> {requestDetails.offer.discountPercentage}% off</span>
                        <span className="promo-offer-code-right"> {requestDetails.offer.discountedAmount? "-"+Number(requestDetails.offer.discountedAmount).toFixed(2): requestDetails.garagejobquote && requestDetails.garagejobquote.discountAmount ? "-"+Number(requestDetails.garagejobquote.discountAmount).toFixed(2) : "--"} {requestDetails.currency} </span>
                      </div>
                    </div>
                    :
                    <div className="promo-offer-block-percent">
                      <div>
                        <span className="promo-offer-code"> {requestDetails.offer.discountAmount} {requestDetails.currency} off</span>
                        <span className="promo-offer-code-right"> {requestDetails.offer.discountedAmount? "-"+Number(requestDetails.offer.discountedAmount).toFixed(2): requestDetails.garagejobquote && requestDetails.garagejobquote.discountAmount  ? "-"+ Number(requestDetails.garagejobquote.discountAmount).toFixed(2) : "--"} {requestDetails.currency} </span>

                      </div>
                    </div>

                  }



                </div>}
                {/*<InspectionRequired garageJobQuoteArr={this.state.garageJobQuoteArr} inspectionAmount={requestDetails.garagejobquote.hasOwnProperty("inspectionamount")? Number(requestDetails.garagejobquote.inspectionamount):0}/>*/}
                {/*(requestDetails.garagejobquote.hasOwnProperty('isinspectionrequired') && requestDetails.garagejobquote.isinspectionrequired) &&
                <div className="quotesSection-subcategories row quotes-section-text" >
                <div className="col-md-9 pad0">
                  <label>
                    <span>Inspection Required</span>
                  </label>
                </div>
                <div className="col-md-3 pad0">
                  <div>
                    <span className="accessories-cost pull-right" style={{color: '#717982'}}> {requestDetails.garagejobquote.inspectionamount} AED</span>
                  </div>
                </div>
                </div>*/}
                {/*{requestDetails.jobStatus != "waiting" && <div className="jobSlider-quotes-total">
                  <div className="desc-block">
                      <h5 className="quotes-total-title">Total</h5>
                      <span className="quotes-total-amount pull-right">
                        {requestDetails.totalamount ?
                          (`${ totalAmount.toFixed(2) } ${requestDetails.currency}`) :
                          (` -- ${requestDetails.currency}`)}
                      </span>
                  </div>
                </div>}*/}
                {requestDetails.jobStatus != "waiting" && <div className="quotesSection-total">
                  {vat?

                  <div className="details">
                    <label>Sub Total</label>
                    <span>

                      {subTotalAmount.toFixed(2)} {requestDetails.garagejobquote ? requestDetails.garagejobquote.currency : ""}

                                                </span>
                  </div>
                 : "" }
                  {vat?
                    <div className="details">
                      <label>VAT ({requestDetails.garagejobquote.garage.garage_taxes[0].value} %)</label>
                      <span>
                      {vatAmount.toFixed(2)} {requestDetails.garagejobquote ? requestDetails.garagejobquote.currency : ""}
                                                </span>
                    </div>
                  : ""}
                  <div className="total">
                    <label>Total</label>
                    <span>
                      {totalAmount.toFixed(2)} {requestDetails.garagejobquote ? requestDetails.garagejobquote.currency : ""}
                                                </span>
                  </div>
                  {! vat?

                  <div><label className="vat-details">All prices include VAT.</label></div>
                  : ""}
                  <div>
                  </div>
                </div>}

                {requestDetails.jobStatus == 'completed' &&
                <div className="payment-container">
                    <div className="payment-status">
                      <div className="desc-block">
                        <h5 className="title">Payment Mode</h5>

                        <div>
                          <h5 className="payment-mode">{requestDetails.paymentstatus.method == "Pay at Shop"? "Pay at Shop": "Online Payment"}</h5>
                          <span className="payment-type pull-right">
                           {requestDetails.paymentstatus.method == "Pay at Shop"? "Cash": "Credit Card"}
                          </span>
                        </div>

                      </div>

                    </div>
                  </div>
                }
                {
                  requestDetails.garagejobnote && requestDetails.garagejobnote.jobnotes &&
                  <div className="desc-block width-50">
                        <h5>Note:</h5>
                        <span>{requestDetails.garagejobnote.jobnotes ? requestDetails.garagejobnote.jobnotes : '-' } </span>
                  </div>
                }
                { requestDetails.adminRemarks ?

                  <div className="desc-block"><h5>Carcility updates :</h5><p>{ requestDetails.adminRemarks }</p></div>

                  : "" }



              </div>
            </div>
          </div>
      </div>
    );
  }
}

export default Quotes;



// WEBPACK FOOTER //
// ./src/components/JobSliderView/Quotes.jsx